import React from 'react';
import SubscriptionPlanTable from './Component/SubscriptionPlan/SubscriptionPlanTable';

const SubscriptionPlanManagement = () => {
    return (
        <div>
            <SubscriptionPlanTable></SubscriptionPlanTable>
        </div>
    )
}

export default SubscriptionPlanManagement;
